<script>

	import { getTraitColor } from '../helpers';
    import { getNewIcon } from '../../card_images';
	import "../shared.css";

	export let index;
	export let trait;

	$: color = getTraitColor(trait);
</script>

<div class="trait" style="--z:{index}">
	<div class="trait-icon">
		<img class="trait-icon" src={getNewIcon(trait)} />
	</div>
	<div class="trait-banner" style="--bgc:{color.background};--c:{color.label}">
		<span class="font-heading">{trait.replace('!', ' except ').toUpperCase()}</span>
	</div>
</div>

<style>
	.trait {
		flex-direction: column;
		align-items: center;
		margin-left: calc(0px - var(--height) / 84.421); /*-4.75px;*/
		z-index: var(--z);
	}
	.trait-icon {
		width: calc(var(--height) / 11.457); /*35px; */
		height:  calc(var(--height) / 11.457); /*35px; */
	}
	.trait-banner {
		color: var(--c);
		font-size: calc(var(--height) / 25.0625); /*16px;*/
		line-height: 1;
		background-color: var(--bgc);
		writing-mode: vertical-lr;
		text-orientation: sideways;
		height: fit-content;
		width: fit-content;
		margin-top: calc(0px - var(--height) / 40.1); /*-10px;*/
		padding: calc(var(--height) / 26.733) 0.1em calc(var(--height) / 40.1) 0.2em; /* 15px 0.1em 10px 0.2em; */
		border-radius: 0 0 calc(var(--height) / 20.05) calc(var(--height) / 20.05); /*0 0 20px 20px;*/
		z-index: -1;
	}
</style>
